import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { FacetCounts } from "@/lib/skills/catalog";
import { ALL_CATEGORIES } from "@/lib/skills/categories";
import type { Category } from "@/lib/skills/types";

export function CategoryTabs({
  facets,
  total,
  value,
  onChange,
}: {
  facets: FacetCounts;
  total: number;
  value: Category | null;
  onChange: (next: Category | null) => void;
}) {
  return (
    <Tabs
      value={value ?? "all"}
      onValueChange={(v) => onChange(v === "all" ? null : (v as Category))}
    >
      <TabsList>
        <TabsTrigger value="all">All · {total}</TabsTrigger>
        {ALL_CATEGORIES.map((c) => (
          <TabsTrigger key={c} value={c}>
            {c} · {facets.category[c]}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
